import { useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { articlesFor, ctaFor, isExternal } from "../../../content/articles";
import "./ccResources.css";

/* Copy and covers live in content/articles.js, shared with the home page and
   /insights. This section is a taste, not the index: the newest few pieces
   written for career centres, with "See all insights" carrying the rest. */
const SHOWN = 4;
const resources = articlesFor("career-centers").slice(0, SHOWN);

const CcResources = () => {
  const trackRef = useRef(null);

  const scrollBy = (direction) => {
    const track = trackRef.current;
    if (!track) return;
    const card = track.querySelector(".cc-res-card");
    const step = card ? card.getBoundingClientRect().width + 22 : 340;
    track.scrollBy({ left: step * direction, behavior: "smooth" });
  };

  return (
    <section className="cc-section cc-resources">
      <div className="home-container cc-res-head">
        <div>
          <h2 className="cc-res-title">What we&rsquo;re seeing in career services</h2>
          <p className="cc-lead cc-res-sub">
            Reports, outlooks, and the occasional strong opinion, written
            for the people running the office.
          </p>
        </div>

        <div className="cc-res-actions">
          <Link className="cc-res-all" to="/insights">
            See all insights
            <ArrowRight size={15} strokeWidth={2.2} />
          </Link>

          <div className="cc-res-arrows">
          <button type="button" onClick={() => scrollBy(-1)} aria-label="Previous">
            <ArrowLeft size={17} strokeWidth={2} />
          </button>
          <button
            type="button"
            className="cc-arrow-on"
            onClick={() => scrollBy(1)}
            aria-label="Next"
          >
              <ArrowRight size={17} strokeWidth={2} />
            </button>
          </div>
        </div>
      </div>

      <div className="cc-res-track" ref={trackRef}>
        {resources.map((article) => {
          const { slug, tone, cover, title, readTime, url } = article;
          const body = (
            <>
              <span className={`cc-res-cover cc-res-${tone}`} aria-hidden="true">
                <img decoding="async" src={cover} alt="" loading="lazy" />
              </span>
              <span className="cc-res-name">{title}</span>
              <span className="cc-res-read">{readTime}</span>
              <span className="cc-res-cta">
                {ctaFor(article)}
                <span className="cc-res-cta-icon" aria-hidden="true">
                  <ArrowRight size={12} strokeWidth={2.5} />
                </span>
              </span>
            </>
          );

          return isExternal(url) ? (
            <a className="cc-res-card" key={slug} href={url} target="_blank" rel="noopener noreferrer">
              {body}
            </a>
          ) : (
            <Link className="cc-res-card" key={slug} to={url}>
              {body}
            </Link>
          );
        })}
      </div>
    </section>
  );
};

export default CcResources;
